var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _text, _text2, _text3, _circle3, _path10, _circle4, _circle5, _path11, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrainWontLetGo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 168 Q200 176 208 168",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175 85 Q165 65 175 50 Q190 35 210 40 Q230 35 240 50 Q250 65 240 85",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M240 85 Q235 80 240 75",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175 85 Q180 80 175 75",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155 60 Q145 50 148 38 Q155 28 168 30",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245 60 Q255 50 252 38 Q245 28 232 30",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165 35 L162 30 L168 32",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235 35 L238 30 L232 32",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 80,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 16,
    opacity: 0.6
  }, "?")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 75,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 16,
    opacity: 0.6
  }, "?")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 55,
    fill: "#fafcfb",
    fontFamily: "system-ui,sans-serif",
    fontSize: 12,
    opacity: 0.4
  }, "?")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 110,
    r: 18,
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M310 96 L310 110 L320 110",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 110,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 130,
    r: 14,
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85 120 L85 130 L92 130",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 130,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 95,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 95,
    r: 1.5,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 170,
    r: 1,
    fill: "#fafcfb",
    opacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 170,
    r: 1,
    fill: "#fafcfb",
    opacity: 0.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 150,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 170,
    r: 2,
    fill: "#38bdf8",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 225,
    rx: 70,
    ry: 12,
    stroke: "#38bdf8",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainWontLetGo);
export default __webpack_public_path__ + "static/media/brain-wont-let-go.a48377c08aca94cbe577348b9e2d7c2d.svg";
export { ForwardRef as ReactComponent };